import { render, staticRenderFns } from "./exposeProductsPreview.vue?vue&type=template&id=0142b0d3&scoped=true"
import script from "./exposeProductsPreview.vue?vue&type=script&lang=js"
export * from "./exposeProductsPreview.vue?vue&type=script&lang=js"
import style0 from "./exposeProductsPreview.vue?vue&type=style&index=0&id=0142b0d3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0142b0d3",
  null
  
)

export default component.exports